import BaseError from './BaseError'

// access-token が無効な場合のエラーをハンドリングするためのエラー
// Pundit で権限不足だったりする場合も Forbidden が返るが一旦考慮しない（access-token が無効になった場合の方が圧倒的に多いため）
// 権限不足のケースは基本的には UI 上で起こらないようになってる...はず...
// 多く起こるようであれば改修
export default class ForbiddenError extends BaseError {}
